import Vue from 'vue'
import { API_URL } from '../../api'
import ProjectsFilter from '../../filters/ProjectsFilter';
const state = {
    projectCreate: {
        createdProject: null,
        creatingProject: false,
        createProjectStatus: null
    },
    projectUpdate: {
        updatedProject: null,
        updatingProject: false,
        updateProjectStatus: null
    },
    projectDelete: {
        deletingProject: false,
        deleteProjectStatus: null
    },
    projectSearch: {
        projectsCount: null,
        projects: [],
        searchingProjects: false,
        searchProjectStatus: null
    },
}
const mutations = {
    ['SET_PROJECT_CREATE'](state, change) {
        state.projectCreate = { ...state.projectCreate, ...change };
    },
    ['SET_PROJECT_UPDATE'](state, change) {
        state.projectUpdate = { ...state.projectUpdate, ...change };
    },
    ['SET_PROJECT_DELETE'](state, change) {
        state.projectDelete = { ...state.projectDelete, ...change };
    },
    ['SET_PROJECT_SEARCH'](state, change) {
        state.projectSearch = { ...state.projectSearch, ...change };
    }
}
const actions = {
    createProject: ({ commit }, payload) => {
        commit('SET_PROJECT_CREATE', { createProjectStatus: null, createdProject: null, creatingProject: true })
        return Vue.http.post(API_URL + '/projects/create', payload).then(response => {
            commit('SET_PROJECT_CREATE', { createProjectStatus: 'success', createdProject: response.body.results.project });
        }).catch(response => {
            commit('SET_PROJECT_CREATE', { createProjectStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_CREATE', { creatingProject: false });
        });
    },
    updateProject: ({ commit }, payload) => {
        commit('SET_PROJECT_UPDATE', { updateProjectStatus: null, updatedProject: null, updatingProject: true })
        return Vue.http.post(API_URL + '/projects/update/' + payload.id, payload)
            .then(response => {
                commit('SET_PROJECT_UPDATE', { updateProjectStatus: 'success', updatedProject: response.body.results.project });
            })
            .catch(response => {
                commit('SET_PROJECT_UPDATE', { updateProjectStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_PROJECT_UPDATE', { updatingProject: false });
            })
    },
    deleteProject: ({ commit }, id) => {
        commit('SET_PROJECT_DELETE', { deleteProjectStatus: null, deletedProject: null, deletingProject: true })
        return Vue.http.delete(API_URL + '/projects/delete/' + id).then(response => {
            commit('SET_PROJECT_DELETE', { deleteProjectStatus: 'success' });
        }).catch(response => {
            commit('SET_PROJECT_DELETE', { deleteProjectStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_DELETE', { deletingProject: false });
        })
    },
    searchProjects: ({ commit }, payload = { filter: ProjectsFilter(), resultMode: 'default' }) => {
        commit('SET_PROJECT_SEARCH', { searchProjectStatus: null, searchProject: null, searchingProjects: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/projects' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_PROJECT_SEARCH', { searchProjectStatus: 'success', projectsCount: response.body.results.projects });

            } else if (payload.resultMode == 2) {
                commit('SET_PROJECT_SEARCH', { searchProjectStatus: 'success', projectsPaginated: response.body.results.projects });

            } else {
                commit('SET_PROJECT_SEARCH', { searchProjectStatus: 'success', projects: response.body.results.projects });
            }
        }).catch(response => {
            commit('SET_PROJECT_SEARCH', { searchProjectStatus: 'failed' });
        }).finally(() => {
            commit('SET_PROJECT_SEARCH', { searchingProjects: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/projectStore.js